import React from 'react'
import Link from 'gatsby-link'

import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";

import image1 from '../../layouts/images/project3/christmas_candle_blow_1937.jpg'
import image2 from '../../layouts/images/project3/christmas_candle_blow_1963_2.jpg'
import image3 from '../../layouts/images/project3/christmas_bible_read.jpg'
import image4 from '../../layouts/images/project3/christmas_childplay_1963.jpg'
import image5 from '../../layouts/images/project3/christmas_childplay_19...4.jpg'
import image6 from '../../layouts/images/project3/christmas_family_tree.jpg'
import image7 from '../../layouts/images/project3/pic_filmstill_koester_detmold1937_02.jpg'
import image8 from '../../layouts/images/project3/pic_filmstill_koester_detmold1937_04.jpg'

const SunSmartPage = () => (

    <div className="container">
        <div className="row">
            <div className="col-lg-5 project-info">
                <h3>Family Movies : Movie Families</h3>
                <div className="project-content">

                    <p>Since the popularisation of the cine camera in the 1930s a lot of families tend to record similar events: Christmas, birthdays, children’s play and daily life activities. Private family movies of the 20th century are an important everyday historical source: e.g. how has the perception on life for families changed? How has the way of filming children changed? At the same time family movies are evidence of how families acquire media technology in every day’s life: e.g. how have families handled the cine/ video camera and who was filming the scenery?</p>
                    <p>The research focused on the analysis of home movies from the 1950s until today to find out about changes and continuities of family lives, in particular the ideals of family and their social practices around Christmas.</p>
                    <p>On the occasion of the International Home Movie Day 2012, the research results and selected film clips were displayed at a public event conducted by the Folklore Studies/ Cultural Anthropology Seminar, University of Muenster and the LWL-Media Center Westphalia. Numerous visitors took up the offer of a guided tour through the movie archive and several home movies were screened on 8mm- and Super 8-movie projectors.</p>
                    <p>A further analysis of the material will be provided upon request.</p>
                </div>
            </div>

            <div className="col-lg-7">

                <div className="slider">
                    <ImageGallery
                        showThumbnails={false}
                        showFullscreenButton={false}
                        autoPlay={true}
                        items={[
                            { original: image1, },
                            { original: image2, },
                            { original: image3, },
                            { original: image4, },
                            { original: image5, },
                            { original: image6, },
                            { original: image7, },
                            { original: image8, },
                        ]} />
                </div>

                <br />
                <br />

                <p className="project-blurb">A cultural anthropological research about family ideals and social practices around Christmas in home movies.</p>

                <ul className="tags">
                    <li>Home Movies</li>
                    <li>International Home Movie Day</li>
                    <li>Family and Kinship Studies</li>
                    <li>Media Technology Studies</li>
                    <li>Childhood Concept</li>
                    <li>Christmas</li>
                </ul>

                <div className="footer-info">
                    <p><span className="highlight">Cooperation Partner:</span> WWU University Münster, LWL-Media Center Westphalia, CHM Center of Home Movies</p>
                    <p><span className="highlight">Source:</span> LWL-Media Center Westphalia Archive with over 1.200 film documents</p>
                    <p><span className="highlight">Date:</span> April 2012 - March 2013</p>
                </div>

            </div>
        </div>
    </div>
)

export default SunSmartPage



// WEBPACK FOOTER //
// ./src/pages/projects/familymovies-moviefamilies.js